import * as React from 'react';

import {Button} from 'shells/button/button';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import {PageContainer, PageTitleBar} from '../../layout';

import {NewBroadcastModal} from '../broadcasts/new-broadcast-modal';
import {MarketingStatsBanner} from '../marketing-stats-banner/marketing-stats-banner';

import {LatestOutreach} from './latest-outreach';
import {RecentlyUpdated} from './recently-updated';

export function Summary() {
    const [isAddingNewBroadcast, setIsAddingNewBroadcast] = React.useState<boolean>(false);
    const [defaultSuggestedEmails, setDefaultSuggestedEmails] = React.useState<boolean>(false);

    return (
        <>
            <PageContainer
                title='Summary'
                pageTitleBar={
                    <PageTitleBar
                        title='Summary'
                        subheaderPrimaryText='A quick look at your most recent outreach activity'
                        buttons={
                            <Button
                                variant='primary'
                                size='big'
                                onClick={() => {
                                    setDefaultSuggestedEmails(false);
                                    setIsAddingNewBroadcast(true);
                                }}
                            >
                                Create new broadcast
                            </Button>
                        }
                    />
                }
            >
                <MarketingStatsBanner />
                <div>
                    <StackLegacy spacing={16}>
                        <RecentlyUpdated
                            onCreateNewBroadcast={() => {
                                setDefaultSuggestedEmails(false);
                                setIsAddingNewBroadcast(true);
                            }}
                        />
                        <LatestOutreach
                            onCreateNewBroadcast={() => {
                                setDefaultSuggestedEmails(true);
                                setIsAddingNewBroadcast(true);
                            }}
                        />
                    </StackLegacy>
                </div>
            </PageContainer>
            <NewBroadcastModal
                isOpen={isAddingNewBroadcast}
                onClose={() => setIsAddingNewBroadcast(false)}
                defaultView={defaultSuggestedEmails ? 'suggested' : undefined}
            />
        </>
    );
}
